import React from 'react';
import { Box, Button, Checkbox, IconButton, InputBase, makeStyles } from '@material-ui/core';
import { i18n } from '../../../../../../language';
import { AddIcon, DeleteIcon } from '../../../../../../components/Icon';
import { getArrayRandomKey } from '../../../../../../utils';
import lengthVerification from '../../../../../../utils/lengthVerification';

const useStyles = makeStyles((theme) => ({
  checkBoxWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '1.2rem',
  },
  itemBox: {
    fontSize: '1.125rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    color: theme.palette.font.main,
  },
  checkBox: {
    '& .MuiSvgIcon-root': {
      height: '2rem',
      width: '2rem',
    },
    '&.MuiCheckbox-colorSecondary.Mui-checked': {
      color: theme.palette.status.green,
      borderRadius: '0.315rem',
    },
    '&.MuiCheckbox-root': {
      color: '#c0c6cb',
    },
  },
  checkInputBox: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    border: '0.0625rem solid #538fff',
    borderRadius: '0.625rem',
    padding: '0 0 0 1.25rem',
  },
  checkInput: {
    fontSize: '1.125rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  btnBox: {
    padding: '0.8rem 0 0',
    '& .MuiButton-root': {
      color: theme.palette.font.sub,
      fontFamily: 'NotoSans-Medium',
      fontWeight: '500',
    },
    '& .MuiButton-root.MuiButton-textPrimary': {
      color: theme.palette.primary.main,
    },
  },
  checklistBtn: {
    textTransform: 'inherit',
  },
}));

const CheckItem = ({ item, index, onChange, onDelete }) => {
  const classes = useStyles();
  const handleKeyDown = (event) => {
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      onChange(event.target.value);
    }
  };

  return (
    <Box display="flex" className={classes.itemBox}>
      <Checkbox className={classes.checkBox} disabled />
      <Box className={classes.checkInputBox}>
        <InputBase
          id={`ehandover-template-del-checkitem-input-${index}`}
          className={classes.checkInput}
          fullWidth
          autoFocus
          placeholder={i18n.t('EHANDOVER_CREATENOTE_CHECKLIST_PLACEHOLDER')}
          value={item.title}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => handleKeyDown(event)}
        />
        <IconButton
          id={`ehandover-template-del-checkitem-${index}`}
          className={classes.deleteIcon}
          color="primary"
          aria-label="upload picture"
          component="span"
          onClick={onDelete}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default function CheckList({ handleChangeTemplate, checkList, initCheckListItem }) {
  const classes = useStyles();

  // add or delete all checklist item
  const handleCheckList = (type) => {
    let newCheckList = [...checkList];
    if (type === 'add') {
      newCheckList.push({ ...initCheckListItem, sortIndex: checkList?.length });
    } else {
      newCheckList = [initCheckListItem];
    }
    handleChangeTemplate('checkLists', newCheckList);
  };

  const handleUpdateCheckItem = (index, val) => {
    if (lengthVerification(val, 201)) {
      return;
    }
    const newCheckList = [...checkList];
    newCheckList[index] = { ...newCheckList[index], title: val };
    handleChangeTemplate('checkLists', newCheckList);
  };

  const handleDeleteCheckItem = (index) => {
    let newCheckList = [...checkList];
    if (newCheckList.length === 1) {
      newCheckList[0] = { ...newCheckList[0], title: '' };
    } else {
      newCheckList.splice(index, 1);
      // 删除check list item之后需要把里面每个checklist item的sortIndex重新排序
      newCheckList = newCheckList.map((item, index) => {
        return { ...item, sortIndex: index };
      });
    }
    handleChangeTemplate('checkLists', newCheckList);
  };

  return (
    <Box>
      <Box className={classes.checkBoxWrapper}>
        {checkList.map((checkItem, index) => {
          return (
            <CheckItem
              key={getArrayRandomKey(index, `template-checkItem-${checkItem.id}`)}
              item={checkItem}
              index={index}
              onChange={(val) => handleUpdateCheckItem(index, val)}
              onDelete={() => handleDeleteCheckItem(index)}
            />
          );
        })}
      </Box>
      <Box display="flex" justifyContent="space-between" className={classes.btnBox}>
        <Button
          id="ehandover-note-template-add-checklist"
          className={classes.checklistBtn}
          color="primary"
          startIcon={<AddIcon style={{ fontSize: '1.063rem' }} />}
          onClick={() => handleCheckList('add')}
        >
          {i18n.t('EHANDOVER_CREATENOTE_CHECKLIST_ADD')}
        </Button>
        <Button
          id="ehandover-note-template-del-checklist"
          className={classes.checklistBtn}
          startIcon={<DeleteIcon />}
          onClick={() => handleCheckList('del')}
        >
          {i18n.t('EHANDOVER_CREATENOTE_CHECKLIST_DELETE')}
        </Button>
      </Box>
    </Box>
  );
}
